module.exports = __webpack_public_path__ + "static/media/cupp_2.07916da7.jpg";